"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.channelOrderDetailApi = channelOrderDetailApi;
exports.channelOrderListApi = channelOrderListApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// 商户端只能查看本商户名下的私域渠道订单
function channelOrderListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/channel/order/list',
    method: 'get',
    params: params
  });
}
function channelOrderDetailApi(orderNo) {
  return (0, _request.default)({
    url: "/admin/merchant/channel/order/detail/".concat(encodeURIComponent(orderNo)),
    method: 'get'
  });
}